import { makeSelectors, combineTokens } from '@utils/css';

const TEMPLATE_CONTAINER_OFFSET_LEFT_PX = 10000;
const tokens = combineTokens("--offset-page", {
  columnGap: "30px",
  paddingTop: "0px",
  paddingBottom: "0px"
});
const templateContainer = "_7ctezt3tj";
const page = "_7cp2b53hr";
const paddingTop = "_7cp9sjo04";
const paddingBottom = "_7cpums5cl";
const pageContent = "_7cp109lop6";
const chunk = "_7ccvpzsjn";
const column = "_7cc14gwk79";
const content = "_7cc1juplnl";
const footer = "_7cf8pb5a1";
const pageSelectors = makeSelectors({
  page,
  pageContent,
  chunkContainer: "chunk--container",
  chunk,
  column,
  content,
  paddingTop,
  paddingBottom,
  header: "page--header",
  footer
});

export { TEMPLATE_CONTAINER_OFFSET_LEFT_PX, chunk, column, content, footer, paddingBottom, paddingTop, page, pageContent, pageSelectors, templateContainer, tokens };
import "./_offset-pages.style.linaria.module.css";
//# sourceMappingURL=_offset-pages.style.js.map
